export default __webpack_public_path__ + "static/media/Psychological_Support.3aae57a8.png";